const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function readJsonResponse(response, context) {
  let body = null;
  try { body = await response.json(); } catch (_) { body = null; }
  if (!response.ok) {
    const error = new Error(extractApiMessage(body) || `${context} failed`);
    error.status = response.status;
    error.payload = body;
    throw error;
  }
  return body;
}

function extractApiMessage(body) {
  if (!body) return '';
  if (typeof body === 'string') return body;
  if (typeof body.message === 'string') return body.message;
  if (typeof body.detail === 'string') return body.detail;
  if (body.detail && typeof body.detail.message === 'string') return body.detail.message;
  return '';
}

export function safeApiMessage(error) {
  if (!error) return 'The jobs service is unavailable right now.';
  return extractApiMessage(error.payload) || error.message || 'The jobs service is unavailable right now.';
}

export async function fetchStoredJobFilters() {
  const response = await fetch(`${BACKEND_URL}/api/jobs/filters`);
  return readJsonResponse(response, 'Loading job filters');
}

export async function searchStoredJobs({ role, location, page = 1, pageSize = 10, sort = 'relevance' }) {
  const params = new URLSearchParams({
    role,
    location,
    page: String(page),
    page_size: String(pageSize),
    sort,
  });
  const response = await fetch(`${BACKEND_URL}/api/jobs/search?${params.toString()}`);
  return readJsonResponse(response, 'Searching jobs');
}

export async function fetchStoredJobDetail(jobId) {
  const response = await fetch(`${BACKEND_URL}/api/jobs/${encodeURIComponent(jobId)}`);
  return readJsonResponse(response, 'Loading job detail');
}